__turbopack_context__.v({
  "availableRoomsAmount": "_9ecW7G_availableRoomsAmount",
  "editButton": "_9ecW7G_editButton",
  "flexContent": "_9ecW7G_flexContent",
  "fullHeight": "_9ecW7G_fullHeight",
  "isDisabled": "_9ecW7G_isDisabled",
  "isFullTag": "_9ecW7G_isFullTag",
  "listItemContainer": "_9ecW7G_listItemContainer",
  "listItemContainerLabel": "_9ecW7G_listItemContainerLabel",
  "listItemContainerSpaceBetween": "_9ecW7G_listItemContainerSpaceBetween",
  "radioButtonDescription": "_9ecW7G_radioButtonDescription",
  "radioButtonWithDescription": "_9ecW7G_radioButtonWithDescription",
});
